import storage from '~/storage';

export const getToken = () => {
  try {
    return window.sessionStorage.getItem('token') ?? undefined;
  } catch (e) {
    return storage().get('token') ?? undefined;
  }
};
